import React, { useEffect, useRef } from 'react'
import Global from '../styles/pages/Global.module.scss'
import styles from '../styles/pages/Login.module.scss'
import { RootState } from '../store/GlobalStore'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import LoginForm from '../components/form/LoginForm'
import planche_a_voile from '../shared/images/Groupe 3413.svg'
import NotificationContainer from '../components/layout/NotificationContainer'
import { useTranslation } from 'react-i18next';
const LoginPage: React.FC = () => {
    const { t, i18n  } = useTranslation();
    const navigate = useNavigate()
    const authState = useSelector((state: RootState) => state.Auth)
    useEffect(() => {
        if (authState.user !== null) {
            navigate('/mon-compte')
        }
    }, [authState.user, navigate])

    return (
        <>
        <NotificationContainer />
        <div className={Global.Pages}>
            <div className={styles.Back}>{t('retour')}</div>
            <div className={styles.mainPicture}>
                <img src={planche_a_voile} alt="activital"/>
                <div className={styles.borderBackground}></div>
            </div>
            <div className={styles.mainTitle}>
                <h2>{t('connect')}</h2>
                <p>{t('connect_sub')}</p>
            </div>
            <LoginForm />
        </div>
        </>
    )
}

export default LoginPage
